<template>
  <div class="border-2 border-gray-800">
    
    <AssetHeader 
      :index="index" 
      :updateValue="updateValue"
      :assetId="asset.id"
      :assetType="parseInt(asset.type)"
      :deleteAsset="deleteAsset"></AssetHeader>

    <div class="flex flex-wrap -mx-2 p-4">
      <div class="w-full lg:w-1/3 px-2">          
        <div class="">
          <InputText 
            label="Address"
            propertyKey="string1"
            objectType="asset"
            objectSubType="ownerOccupiedProperty"
            ref="inputAddress"
            :index="index"
            :objectId="asset.id"
            :value="asset.string1 != null ? asset.string1 : (latestAddress != null ? latestAddress : null)"
            :updateValue="updateValue"
            :required="true" />

          <div class="mt-1 text-right" v-if="asset.string1 != null ? asset.string1 : (latestAddress != null ? latestAddress : null)">
            <a href="#" class="text-gray-700 hover:underline" @click.prevent="$modal.show('map-modal', { 
              address : asset.string1 != null ? asset.string1 : (latestAddress != null ? latestAddress : null)
            })">Show this address on map</a>
          </div>
        </div>

        <div class="mt-6">
          <InputDatePickerReadOnly 
            label="Date of purchase"
            propertyKey="purchased_at"
            objectType="asset"
            :maxDate="today"
            :objectId="asset.id"
            :index="index"
            :value="asset.purchased_at"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="w-full lg:w-1/3 px-2 mt-6 lg:mt-0">
        <InputDollarValue 
          propertyKey="value"
          objectType="asset"
          label="Value"
          objectSubType="savings"
          :required="true"
          :objectId="asset.id"
          :index="index"
          :value="asset.value"
          :updateValue="updateValue"/>
      </div>

      <div class="w-full lg:w-1/3 px-2 mt-6 lg:mt-0">
        <Ownership :asset="asset" />
      </div>
    </div>

  </div>
</template>

<script>
  import axios                    from 'axios'
  import AssetHeader              from '../AssetHeader'
  import InputText                from '@/shared/components/form/InputText'
  import InputDollarValue         from '@/shared/components/form/InputDollarValue'
  import InputDatePickerReadOnly  from '@/shared/components/form/InputDatePickerReadOnly'
  import Ownership                from '@/shared/components/Ownership'

  export default {

    components: {
      AssetHeader,
      InputText,
      Ownership,
      InputDatePickerReadOnly,
      InputDollarValue
    },

    props : {

      asset : {
        type : Object,
        required : true
      },

      index : {
        type : Number,
        required : false
      },

      updateValue : {
        type     : Function,
        required : false
      },

      deleteAsset : {
        type    : Function,
        required: false
      },
    },

    data() {
      return {
        latestAddress : null
      }
    },

    created() {

      // when this is created, go fetch the current address of the client
      this.showLoader("Loading...")
      this.apiGet({
        clientId : this.$route.params.clientId,
      }, 'address/latest-address', (address) => {
        this.hideLoader()

        this.latestAddress = (address.unit_number ? address.unit_number + '/' : '/') + 
                             (address.street_number ? address.street_number + ' ' : '') +
                             (address.street_name ? address.street_name + ' ' : '') + 
                             (address.street_type ? address.street_type + ' ' : '') + 
                             (address.suburb ? address.suburb : '') + " " + 
                             (address.state ? address.state : '') + " " + 
                             (address.postcode ? address.postcode : '') + " " +
                             (address.country ? address.country : '')

        this.localUpdateValue('string1', this.latestAddress)
      })
    },

    methods : {

      // localUpdateValue steps in between the child component and the
      // parent component in order to inject an extra argument to the 
      // update value function since for assets, we also need which
      // asset we are currently updating
      localUpdateValue(key, value) {
        this.updateValue({
          key : key,
          value : value,
          objectId : this.asset.id, 
          index : this.index
        })
      }
    }
  }
</script>